import OccurrenceTypeRepository from '@/shared/http/repositories/socialProject/occurrence-type'
import BreadCrumb from '@/components/layout/BreadCrumb/breadCrumb.vue'
import NewRegister from '@/components/layout/NewRegister/newRegister.vue'
import OccurrenceType from '@/shared/models/occurrenceType'
import { IsSuccessCode } from '@/shared/utils/API'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'NovoTipoDeOcorrência',

  components: {
    [BreadCrumb.name]: BreadCrumb,
    [NewRegister.name]: NewRegister
  },

  data: () => ({
    placeholder: 'Nome',
    title: 'Tipo de Ocorrência',
    occurrenceType: new OccurrenceType(),
    isNew: true
  }),

  computed: {
    breadCrumb() {
      return {
        breadcrumbItems: [
          {
            text: 'Dashboard',
            href: this.$router.resolve({ name: 'Dashboard' }).href
          },
          {
            text: 'Tipos de Ocorrência',
            href: this.$router.resolve({ name: 'OccurrenceType' }).href
          },
          {
            text: 'Novo Tipo de Ocorrência',
            active: true
          }
        ]
      }
    }
  },

  methods: {
    create(occurrenceType) {
      loading.push()
      OccurrenceTypeRepository.Create(occurrenceType)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          loading.pop()
          toast.success('Tipo de Ocorrência criado com sucesso', 'NOVO TIPO DE OCORRÊNCIA')
          Promise.resolve()
          return this.$router.replace({ name: 'OccurrenceType' })
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao criar tipo de ocorrência', 'ERRO')
        })
    }
  }
}
